import { Version } from './version';

export const UI_VERSION = new Version('1.0.0').full;
